import { buildDemoCommunicationNetworkGraphInspectorResponse } from '@web/lib/demo/communicationNetworkGraph/inspectorMocks';
export var communicationNetworkGraphInspector = function (input) {
    return buildDemoCommunicationNetworkGraphInspectorResponse(input);
};
